const ChatClientChannelConnectionError = {
  chatClientDisabled: 'chatClientDisabled',
  unknown: 'unknown',
};

export default ChatClientChannelConnectionError;
